import { handleResponse } from './handleresponse'
import { chatapi } from '@/services/config'

export const ChatServices = {
  getChatList,
  getMessage,
  addMessage,
  sendMessage,
  readgroupmsg
}

function getChatList () {
  return fetch(chatapi + '/api/messanger/v1/chats', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getMessage (groupid) {
  return fetch(chatapi + '/api/messanger/v1/messages?groupid=' + groupid + '&sort=id,DESC', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function readgroupmsg (groupid) {
  return fetch(chatapi + '/api/messanger/v1/groupreadmsg/' + groupid, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function addMessage (postdata) {
  return fetch(chatapi + '/api/messanger/v1/message', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function sendMessage (postdata) {
  return fetch(chatapi + '/api/messanger/v1/message', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
